import { createApp } from "vue";
import { createPinia } from "pinia";
import { createYmaps } from "vue-yandex-maps";
import VueApexCharts from "vue3-apexcharts";

// Импортируем глобальные стили
import "./styles/style.styl";

import App from "./App.vue";
import router from "./router";
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";
import directives from "./directives";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { IconComponent } from "@/components/ui";

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);

app.component("infinite-loading", InfiniteLoading);
app.component("IconComponent", IconComponent);

app.use(router);
app.use(directives);
app.use(VueApexCharts);

if (import.meta.env.VITE_API_KEY_YANDEX_MAP) {
  app.use(
    createYmaps({
      apikey: import.meta.env.VITE_API_KEY_YANDEX_MAP,
    })
  );
} else {
  console.warn("Укажите ключ яндекс карты, для работы яндекс карты VITE_API_KEY_YANDEX_MAP");
}

const options = {
  containerClassName: "toasts-container",
  toastClassName: "toasts-item",
  bodyClassName: ["toasts-item-body"],
  position: "bottom-right",
  pauseOnFocusLoss: false,
  timeout: 5000,
};
app.use(Toast, options);

app.mount("#app");
